import { NgModule } from '@angular/core'
import type { Routes } from '@angular/router'
import { RouterModule } from '@angular/router'

import {
  ArticleDetailsComponent,
  articleDetailsResolver,
  articleSeo,
} from '../articles/article-details/article-details.component'
import {
  EditionOverviewComponent,
  editionDetailResolver,
  editionSeo,
} from '../editions/edition-overview/edition-overview.component'
import {
  MagazinesAndJournalsDetailPageComponent,
  magazineDetailResolver,
  magazineSeo,
} from './magazines-and-journals-detail-page/magazines-and-journals-detail-page.component'

const routes: Routes = [
  {
    path: 'detail/:id',
    component: MagazinesAndJournalsDetailPageComponent,
    resolve: { magazineDetail: magazineDetailResolver },
    data: { seo: magazineSeo },
  },
  {
    path: 'detail/:id/:slug',
    component: MagazinesAndJournalsDetailPageComponent,
    resolve: { magazineDetail: magazineDetailResolver },
    data: { seo: magazineSeo },
  },
  {
    path: 'detail/:id/:slug/edition/:id',
    component: EditionOverviewComponent,
    resolve: { editionDetail: editionDetailResolver },
    data: { seo: editionSeo },
  },
  {
    path: 'detail/:id/:slug/edition/:id/article/:id',
    component: ArticleDetailsComponent,
    resolve: { articleDetails: articleDetailsResolver },
    data: { seo: articleSeo },
  },
  {
    path: 'selection-essence/detail/:id',
    component: MagazinesAndJournalsDetailPageComponent,
    resolve: { magazineDetail: magazineDetailResolver },
    data: { seo: magazineSeo },
  },
  {
    path: 'selection-essence/detail/:id/:slug',
    component: MagazinesAndJournalsDetailPageComponent,
    resolve: { magazineDetail: magazineDetailResolver },
    data: { seo: magazineSeo },
  },
  { path: '', redirectTo: '/', pathMatch: 'full' },
]
// TODO: Use the slug instead of the id in the route
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MagazinesAndJournalsRoutingModule {}
